export default __webpack_public_path__ + "static/media/complementary--restriction-in-both-directions--g1.076c822f.png";